<template>
  <div>
    <dialog-component
      :dialogData="dialogData"
      :isShow="isShow"
      :isUnitButton = 'false'
      :unitText="'Cancel'"
      :width="375"
      @cancel="handleCancel"
      @next="handleSave"
    >
      <div class="email-dialog">
        <p class="pd-b-20 color-dark">This policy will no longer be adjustable. Continue?</p>
        <el-form
          ref="form"
          :model="formData"
          :rules="rules">
          <div class="form-item ">
            <span>Insurer</span>
            <el-form-item
              ref="quote.company_id"
              prop="quote.company_id"
              :rules="rules.select"
            >
              <v-select
                v-model="formData.quote.company_id"
                :list="insureList"
                :rules="rules.select"
              />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Plan Name</span>
            <el-form-item
              ref="quote.plan_name"
              prop="quote.plan_name"
              :rules="rules.select">
              <v-input
                v-model="formData.quote.plan_name"
                :rules="rules.input"
              />
            </el-form-item>
          </div>
          <sme-premium
            ref="premium"
            :class-id="form.class_id"
            :customer-id="form.customer_id"
            :customer="form.customer"
            :order-id="orderId"
            :is-out-coupon="true"
            :form="formData"
            @open="handleCoupon">
          </sme-premium>
        </el-form>
      </div>
    </dialog-component>
    <coupon-dialog
      ref="out-coupon-dialog"
      :class-id="form.class_id"
      :customer-id="form.customer_id"
      :customer="form.customer"
      :order-id="orderId"
      :isQuote="false"
      @coupon="computedCoupon"
    >
    </coupon-dialog>
  </div>

</template>

<script>
import smePremium from '@/views/components/sme-premium-form'
import {getSMEPremiumData, smeIssuing} from '@api/sme'
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import MixinFormat from '@/mixins/format'
import CouponDialog from '@/views/components/refer-coupon-select-dialog'

export default {
  name: 'editEmailDialog',
  components:{
    smePremium,
    CouponDialog
  },
  mixins: [MixinOptions, MixinRules, MixinFormat],
  props:{
    value: {
      type: Boolean,
      default: false
    },
    customerId:{
      type:[ Number,String],
      default:''
    },
    orderId:{
      type:[ Number,String],
      default:''
    },
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  data(){
    return{
      isShow:false,
      formData:{
        quote:{
          plan_name:'',
          company_id:'',
        },
        premium_other:{

        },
      }
    }
  },
  computed:{
    dialogData(){
      return{
        title:'Mark As Issuing',
      }
    },
    localAllOptions() {
      let {class_id } = this.form
      return this[`smeOptions${class_id}`]||{}
    },
    insureList(){
      let {insurer} = this.localAllOptions
      return insurer||[]
    },
  },
  watch:{
    value: {
      immediate: true,
      handler(status) {
        if(status !== this.isShow) {
          this.isShow = status
          this.$emit('input',this.isShow)
        }
        if(status){
          this.network().getSMEPremiumData()
        }
      }
    },
  },
  methods:{
    computedCoupon(data){
      let params = {}
      params.coupon = {selectCode: 1, ...data}
      this.$refs['premium'].applyCode(params)
    },
    handleCoupon(){
      this.$refs['out-coupon-dialog'].changeDialog()
    },
    handleShow(){
      this.isShow = !this.isShow
    },
    handleLink(){
      this.isShow = false
      this.$emit('refresh')
    },
    handleChange(type){
      this.isShow = false
      this.$emit('openDialog',type)
    },
    handleSave(){
      this.$refs['form'].validate(async (valid, rules) => {
        if(valid){
          let premium = await this.$refs['premium'].submitForm()
          let params = {
            ...this.formData,
            ...premium
          }
          if(premium.is_match==0)
            return
          this.network().smeIssuing(params)

        }else {
          this.scrollToValidDom(rules)
        }
      })
    },
    handleCancel(){
      this.$emit('input',false)
    },
    network(){
      return{
        getSMEPremiumData:async ()=>{
          const {data} = await getSMEPremiumData({
            order_id:this.orderId
          })
          this.formData = {...this.formData,...data}
          this.$nextTick(()=>{
            this.$refs.premium.handleComputedData()
          })
        },
        smeIssuing:async (params)=>{
          const {data} = await smeIssuing({
            order_id:this.orderId,
            ...this.formData.quote,
            premium:params.premium,
            premium_other:params.premium_other
          })
          this.isShow = false
          this.$emit('update')
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .email-dialog{
    width: 343px;
  }
</style>
